
export type TextPaper = {
  id: string;
  type: "text";
  pos: [number, number];
  lines: string[];
};

export type ImagePaper = {
  id: string;
  type: "image";
  pos: [number, number];
  imageUrl: string;
};

export type Paper = TextPaper | ImagePaper;

export type DesktopState = {
  tool: "HAND" | "SCISSORS" | "BIN";
  volume: "SILENT" | "NOISY";
  teletype: {
    line: string;
    activePaper: string[];
  };
  pinboard: {
    papers: Paper[];
  };
  help: string,
  turboSpeed: number;
  version: number;
};

export function addNewLine(desktopState: DesktopState) {
  return {
    ...desktopState,
    teletype: {
      ...desktopState.teletype,
      activePaper: [...desktopState.teletype.activePaper, desktopState.teletype.line],
      line: ""
    }
  };
}

export function preprocessInput(input: string) {
  let processed = "";
  for (let i = 0; i < input.length; i++) {
    let char = input[i];
    let nextChar = input[i + 1] || null;
    if (char == "#") {
      processed = processed.slice(0, -1);
    } else if (char == "@") {
      processed = "";
    } else if (char == "\\" && nextChar == "#") {
      processed += "#";
      i += 1;
    } else if (char == "\\" && nextChar == "@") {
      processed += "@";
      i += 1;
    } else {
      processed += char;
    }
  }
  return processed;
}

export function typeChar(desktopState: DesktopState, char: string) {
  return {
    ...desktopState,
    teletype: {
      ...desktopState.teletype,
      line: desktopState.teletype.line + char
    }
  };
}
